import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class QuoteService {
    // Get all 
    static async getAllQuotes(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.QUOTES; // endpoint
        const requestModel = { storeId };

        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch quotes.');
            return [];
        }
    }

    // Create 
    static async addNewQuote(data) {
        //debugger
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.QUOTES}/create`; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Quote added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new quote.');
        }
    }

    // Get by ID
    static async getQuoteById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.QUOTES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch quote by ID');
        }
    }

    // Update 
    static async updateQuoteById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.QUOTES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Quote updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update quote.');
        }
    }

    // Delete 
    static async deleteQuote(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.QUOTES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                handleNotify('Quote deleted successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
                return responseModel;
            } else {
                throw new Error('Failed to delete quote.');
            }
        } catch (error) {
            console.error('Error deleting quote:', error);
            throw error;
        }
    }

    // Delete multiple 
    static async deleteManyQuotes(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.QUOTES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
